/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { InviteOrganizationUser } from '../model';
// @ts-ignore
import type { OrganizationRoles } from '../model';
// @ts-ignore
import type { OrganizationUser } from '../model';
// @ts-ignore
import type { OrganizationUserPaginated } from '../model';
// @ts-ignore
import type { OrganizationUserRoleBulkUpdate } from '../model';
// @ts-ignore
import type { OrganizationUserRoleUpdate } from '../model';
// @ts-ignore
import type { OrganizationUserStatusUpdate } from '../model';
// @ts-ignore
import type { OrganizationUserUpdate } from '../model';
// @ts-ignore
import type { PlatformRoles } from '../model';
// @ts-ignore
import type { PlatformUser } from '../model';
// @ts-ignore
import type { PlatformUserPaginated } from '../model';
// @ts-ignore
import type { PlatformUserRoleBulkUpdate } from '../model';
// @ts-ignore
import type { PlatformUserRoleUpdate } from '../model';
// @ts-ignore
import type { SignupLink } from '../model';
// @ts-ignore
import type { TermsReset } from '../model';
// @ts-ignore
import type { UserSorting } from '../model';
// @ts-ignore
import type { UserState } from '../model';
/**
 * UsersApi - axios parameter creator
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Assign a single organization role to a user.
         * @summary Add Organization User Role
         * @param {string} userId 
         * @param {OrganizationUserRoleUpdate} organizationUserRoleUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrganizationUserRole: async (userId: string, organizationUserRoleUpdate: OrganizationUserRoleUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('addOrganizationUserRole', 'userId', userId)
            // verify required parameter 'organizationUserRoleUpdate' is not null or undefined
            assertParamExists('addOrganizationUserRole', 'organizationUserRoleUpdate', organizationUserRoleUpdate)
            const localVarPath = `/users/{user_id}/roles`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationUserRoleUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Assign a single platform role to a user.
         * @summary Add Platform User Role
         * @param {string} userId 
         * @param {PlatformUserRoleUpdate} platformUserRoleUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPlatformUserRole: async (userId: string, platformUserRoleUpdate: PlatformUserRoleUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('addPlatformUserRole', 'userId', userId)
            // verify required parameter 'platformUserRoleUpdate' is not null or undefined
            assertParamExists('addPlatformUserRole', 'platformUserRoleUpdate', platformUserRoleUpdate)
            const localVarPath = `/platform/users/{user_id}/roles`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(platformUserRoleUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel every pending invitation for the user.
         * @summary Cancel Pending User Invites
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelPendingUserInvites: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('cancelPendingUserInvites', 'userId', userId)
            const localVarPath = `/users/{user_id}/cancel-invites`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Hard-delete an organization user.
         * @summary Delete Organization User
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteOrganizationUser', 'userId', userId)
            const localVarPath = `/users/{user_id}`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the most recent valid pending signup link for an invited user. Mirrors v1.
         * @summary Get Organization User Signup Link
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationUserSignupLink: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getOrganizationUserSignupLink', 'userId', userId)
            const localVarPath = `/users/{user_id}/signup-link`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get paginated organization users for the current user\'s organization.
         * @summary Get Organization Users
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {UserSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [nameOrEmail] 
         * @param {UserState | null} [status] 
         * @param {boolean | null} [includeInactive] 
         * @param {boolean} [exactMatch] 
         * @param {Array<string>} [ids] Keep only these users. Platform users with full organization access reach any organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationUsers: async (page?: number, size?: number, sortBy?: UserSorting | null, descending?: boolean | null, nameOrEmail?: string | null, status?: UserState | null, includeInactive?: boolean | null, exactMatch?: boolean, ids?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (nameOrEmail !== undefined) {
                localVarQueryParameter['name_or_email'] = nameOrEmail;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (includeInactive !== undefined) {
                localVarQueryParameter['include_inactive'] = includeInactive;
            }

            if (exactMatch !== undefined) {
                localVarQueryParameter['exact_match'] = exactMatch;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one platform user by id.
         * @summary Get Platform User
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getPlatformUser', 'userId', userId)
            const localVarPath = `/platform/users/{user_id}`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get paginated platform users.
         * @summary Get Platform Users
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {UserSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [nameOrEmail] 
         * @param {UserState | null} [status] 
         * @param {boolean | null} [includeInactive] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformUsers: async (page?: number, size?: number, sortBy?: UserSorting | null, descending?: boolean | null, nameOrEmail?: string | null, status?: UserState | null, includeInactive?: boolean | null, exactMatch?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/platform/users/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (nameOrEmail !== undefined) {
                localVarQueryParameter['name_or_email'] = nameOrEmail;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (includeInactive !== undefined) {
                localVarQueryParameter['include_inactive'] = includeInactive;
            }

            if (exactMatch !== undefined) {
                localVarQueryParameter['exact_match'] = exactMatch;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new user (state=invited) in the target organization and email an activation link.  The target organization is resolved once via ``get_organization_schema_from_request`` (path/query/body ``organization_id``, else the caller\'s own org) and used for BOTH the authorization check and the invite, so the two can never diverge. Targeting another org therefore requires platform-wide organization access (superadmin / organization manager), enforced by ``check_if_user_has_organization_rights`` against that same resolved org.  If the email already belongs to a user in the same org → 400. If the email belongs to a user in another org → 400. If the email belongs to an org-less user → silently attach to the target org (no email).
         * @summary Invite User
         * @param {InviteOrganizationUser} inviteOrganizationUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUser: async (inviteOrganizationUser: InviteOrganizationUser, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteOrganizationUser' is not null or undefined
            assertParamExists('inviteUser', 'inviteOrganizationUser', inviteOrganizationUser)
            const localVarPath = `/users/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteOrganizationUser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List organization roles for a user.
         * @summary List Organization User Roles
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizationUserRoles: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('listOrganizationUserRoles', 'userId', userId)
            const localVarPath = `/users/{user_id}/roles`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List platform roles for a user.
         * @summary List Platform User Roles
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlatformUserRoles: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('listPlatformUserRoles', 'userId', userId)
            const localVarPath = `/platform/users/{user_id}/roles`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Override all organization roles for a user.
         * @summary Override Organization User Roles
         * @param {string} userId 
         * @param {OrganizationUserRoleBulkUpdate} organizationUserRoleBulkUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overrideOrganizationUserRoles: async (userId: string, organizationUserRoleBulkUpdate: OrganizationUserRoleBulkUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('overrideOrganizationUserRoles', 'userId', userId)
            // verify required parameter 'organizationUserRoleBulkUpdate' is not null or undefined
            assertParamExists('overrideOrganizationUserRoles', 'organizationUserRoleBulkUpdate', organizationUserRoleBulkUpdate)
            const localVarPath = `/users/{user_id}/roles`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationUserRoleBulkUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Override all platform roles for a user.
         * @summary Override Platform User Roles
         * @param {string} userId 
         * @param {PlatformUserRoleBulkUpdate} platformUserRoleBulkUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overridePlatformUserRoles: async (userId: string, platformUserRoleBulkUpdate: PlatformUserRoleBulkUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('overridePlatformUserRoles', 'userId', userId)
            // verify required parameter 'platformUserRoleBulkUpdate' is not null or undefined
            assertParamExists('overridePlatformUserRoles', 'platformUserRoleBulkUpdate', platformUserRoleBulkUpdate)
            const localVarPath = `/platform/users/{user_id}/roles`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(platformUserRoleBulkUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a single organization role from a user.
         * @summary Remove Organization User Role
         * @param {OrganizationRoles} roleName 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOrganizationUserRole: async (roleName: OrganizationRoles, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleName' is not null or undefined
            assertParamExists('removeOrganizationUserRole', 'roleName', roleName)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeOrganizationUserRole', 'userId', userId)
            const localVarPath = `/users/{user_id}/roles/{role_name}`
                .replace('{role_name}', encodeURIComponent(String(roleName)))
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a single platform role from a user.
         * @summary Remove Platform User Role
         * @param {PlatformRoles} platformRole 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePlatformUserRole: async (platformRole: PlatformRoles, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformRole' is not null or undefined
            assertParamExists('removePlatformUserRole', 'platformRole', platformRole)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removePlatformUserRole', 'userId', userId)
            const localVarPath = `/platform/users/{user_id}/roles/{platform_role}`
                .replace('{platform_role}', encodeURIComponent(String(platformRole)))
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel any pending invites and send a fresh one. Mirrors v1 semantics.
         * @summary Resend User Invite
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendUserInvite: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('resendUserInvite', 'userId', userId)
            const localVarPath = `/users/{user_id}/resend-invite`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reset terms acceptance for all users, except users of organizations with custom terms and conditions.  By default the reset is applied and every affected user must re-accept the terms on next login. Pass ``dry_run=true`` to only compute the counts without writing anything.
         * @summary Reset Users Terms Accepted
         * @param {boolean} [dryRun] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUsersTermsAccepted: async (dryRun?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/platform/users/terms-and-conditions/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dryRun !== undefined) {
                localVarQueryParameter['dry_run'] = dryRun;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Trigger the IdP to email a password-reset link to the target user.
         * @summary Send Password Reset Email
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPasswordResetEmail: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('sendPasswordResetEmail', 'userId', userId)
            const localVarPath = `/users/{user_id}/password-reset`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Clear the IdP lock on a user and restore their access.
         * @summary Unlock Organization User
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockOrganizationUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('unlockOrganizationUser', 'userId', userId)
            const localVarPath = `/users/{user_id}/unlock`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update basic profile fields for an organization user.
         * @summary Update Organization User
         * @param {string} userId 
         * @param {OrganizationUserUpdate} organizationUserUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationUser: async (userId: string, organizationUserUpdate: OrganizationUserUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateOrganizationUser', 'userId', userId)
            // verify required parameter 'organizationUserUpdate' is not null or undefined
            assertParamExists('updateOrganizationUser', 'organizationUserUpdate', organizationUserUpdate)
            const localVarPath = `/users/{user_id}`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationUserUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the status (state) of an organization user.
         * @summary Update Organization User Status
         * @param {string} userId 
         * @param {OrganizationUserStatusUpdate} organizationUserStatusUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationUserStatus: async (userId: string, organizationUserStatusUpdate: OrganizationUserStatusUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateOrganizationUserStatus', 'userId', userId)
            // verify required parameter 'organizationUserStatusUpdate' is not null or undefined
            assertParamExists('updateOrganizationUserStatus', 'organizationUserStatusUpdate', organizationUserStatusUpdate)
            const localVarPath = `/users/{user_id}/status`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationUserStatusUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * Assign a single organization role to a user.
         * @summary Add Organization User Role
         * @param {string} userId 
         * @param {OrganizationUserRoleUpdate} organizationUserRoleUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrganizationUserRole(userId: string, organizationUserRoleUpdate: OrganizationUserRoleUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationRoles>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOrganizationUserRole(userId, organizationUserRoleUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.addOrganizationUserRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Assign a single platform role to a user.
         * @summary Add Platform User Role
         * @param {string} userId 
         * @param {PlatformUserRoleUpdate} platformUserRoleUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPlatformUserRole(userId: string, platformUserRoleUpdate: PlatformUserRoleUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlatformRoles>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPlatformUserRole(userId, platformUserRoleUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.addPlatformUserRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cancel every pending invitation for the user.
         * @summary Cancel Pending User Invites
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelPendingUserInvites(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelPendingUserInvites(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.cancelPendingUserInvites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Hard-delete an organization user.
         * @summary Delete Organization User
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrganizationUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrganizationUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.deleteOrganizationUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the most recent valid pending signup link for an invited user. Mirrors v1.
         * @summary Get Organization User Signup Link
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationUserSignupLink(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignupLink>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationUserSignupLink(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getOrganizationUserSignupLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get paginated organization users for the current user\'s organization.
         * @summary Get Organization Users
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {UserSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [nameOrEmail] 
         * @param {UserState | null} [status] 
         * @param {boolean | null} [includeInactive] 
         * @param {boolean} [exactMatch] 
         * @param {Array<string>} [ids] Keep only these users. Platform users with full organization access reach any organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationUsers(page?: number, size?: number, sortBy?: UserSorting | null, descending?: boolean | null, nameOrEmail?: string | null, status?: UserState | null, includeInactive?: boolean | null, exactMatch?: boolean, ids?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationUserPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationUsers(page, size, sortBy, descending, nameOrEmail, status, includeInactive, exactMatch, ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getOrganizationUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one platform user by id.
         * @summary Get Platform User
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlatformUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlatformUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlatformUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getPlatformUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get paginated platform users.
         * @summary Get Platform Users
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {UserSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [nameOrEmail] 
         * @param {UserState | null} [status] 
         * @param {boolean | null} [includeInactive] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlatformUsers(page?: number, size?: number, sortBy?: UserSorting | null, descending?: boolean | null, nameOrEmail?: string | null, status?: UserState | null, includeInactive?: boolean | null, exactMatch?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlatformUserPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlatformUsers(page, size, sortBy, descending, nameOrEmail, status, includeInactive, exactMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getPlatformUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new user (state=invited) in the target organization and email an activation link.  The target organization is resolved once via ``get_organization_schema_from_request`` (path/query/body ``organization_id``, else the caller\'s own org) and used for BOTH the authorization check and the invite, so the two can never diverge. Targeting another org therefore requires platform-wide organization access (superadmin / organization manager), enforced by ``check_if_user_has_organization_rights`` against that same resolved org.  If the email already belongs to a user in the same org → 400. If the email belongs to a user in another org → 400. If the email belongs to an org-less user → silently attach to the target org (no email).
         * @summary Invite User
         * @param {InviteOrganizationUser} inviteOrganizationUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteUser(inviteOrganizationUser: InviteOrganizationUser, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteUser(inviteOrganizationUser, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.inviteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List organization roles for a user.
         * @summary List Organization User Roles
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOrganizationUserRoles(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationRoles>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOrganizationUserRoles(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.listOrganizationUserRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List platform roles for a user.
         * @summary List Platform User Roles
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPlatformUserRoles(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlatformRoles>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPlatformUserRoles(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.listPlatformUserRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Override all organization roles for a user.
         * @summary Override Organization User Roles
         * @param {string} userId 
         * @param {OrganizationUserRoleBulkUpdate} organizationUserRoleBulkUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async overrideOrganizationUserRoles(userId: string, organizationUserRoleBulkUpdate: OrganizationUserRoleBulkUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationRoles>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.overrideOrganizationUserRoles(userId, organizationUserRoleBulkUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.overrideOrganizationUserRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Override all platform roles for a user.
         * @summary Override Platform User Roles
         * @param {string} userId 
         * @param {PlatformUserRoleBulkUpdate} platformUserRoleBulkUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async overridePlatformUserRoles(userId: string, platformUserRoleBulkUpdate: PlatformUserRoleBulkUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlatformRoles>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.overridePlatformUserRoles(userId, platformUserRoleBulkUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.overridePlatformUserRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a single organization role from a user.
         * @summary Remove Organization User Role
         * @param {OrganizationRoles} roleName 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeOrganizationUserRole(roleName: OrganizationRoles, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeOrganizationUserRole(roleName, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.removeOrganizationUserRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a single platform role from a user.
         * @summary Remove Platform User Role
         * @param {PlatformRoles} platformRole 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removePlatformUserRole(platformRole: PlatformRoles, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removePlatformUserRole(platformRole, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.removePlatformUserRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cancel any pending invites and send a fresh one. Mirrors v1 semantics.
         * @summary Resend User Invite
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendUserInvite(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendUserInvite(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.resendUserInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reset terms acceptance for all users, except users of organizations with custom terms and conditions.  By default the reset is applied and every affected user must re-accept the terms on next login. Pass ``dry_run=true`` to only compute the counts without writing anything.
         * @summary Reset Users Terms Accepted
         * @param {boolean} [dryRun] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetUsersTermsAccepted(dryRun?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TermsReset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetUsersTermsAccepted(dryRun, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.resetUsersTermsAccepted']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Trigger the IdP to email a password-reset link to the target user.
         * @summary Send Password Reset Email
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendPasswordResetEmail(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendPasswordResetEmail(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.sendPasswordResetEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Clear the IdP lock on a user and restore their access.
         * @summary Unlock Organization User
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlockOrganizationUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlockOrganizationUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.unlockOrganizationUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update basic profile fields for an organization user.
         * @summary Update Organization User
         * @param {string} userId 
         * @param {OrganizationUserUpdate} organizationUserUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationUser(userId: string, organizationUserUpdate: OrganizationUserUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationUser(userId, organizationUserUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.updateOrganizationUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the status (state) of an organization user.
         * @summary Update Organization User Status
         * @param {string} userId 
         * @param {OrganizationUserStatusUpdate} organizationUserStatusUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationUserStatus(userId: string, organizationUserStatusUpdate: OrganizationUserStatusUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationUserStatus(userId, organizationUserStatusUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.updateOrganizationUserStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * Assign a single organization role to a user.
         * @summary Add Organization User Role
         * @param {UsersApiAddOrganizationUserRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrganizationUserRole(requestParameters: UsersApiAddOrganizationUserRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<OrganizationRoles>> {
            return localVarFp.addOrganizationUserRole(requestParameters.userId, requestParameters.organizationUserRoleUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Assign a single platform role to a user.
         * @summary Add Platform User Role
         * @param {UsersApiAddPlatformUserRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPlatformUserRole(requestParameters: UsersApiAddPlatformUserRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PlatformRoles>> {
            return localVarFp.addPlatformUserRole(requestParameters.userId, requestParameters.platformUserRoleUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel every pending invitation for the user.
         * @summary Cancel Pending User Invites
         * @param {UsersApiCancelPendingUserInvitesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelPendingUserInvites(requestParameters: UsersApiCancelPendingUserInvitesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelPendingUserInvites(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Hard-delete an organization user.
         * @summary Delete Organization User
         * @param {UsersApiDeleteOrganizationUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationUser(requestParameters: UsersApiDeleteOrganizationUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteOrganizationUser(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the most recent valid pending signup link for an invited user. Mirrors v1.
         * @summary Get Organization User Signup Link
         * @param {UsersApiGetOrganizationUserSignupLinkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationUserSignupLink(requestParameters: UsersApiGetOrganizationUserSignupLinkRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignupLink> {
            return localVarFp.getOrganizationUserSignupLink(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get paginated organization users for the current user\'s organization.
         * @summary Get Organization Users
         * @param {UsersApiGetOrganizationUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationUsers(requestParameters: UsersApiGetOrganizationUsersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationUserPaginated> {
            return localVarFp.getOrganizationUsers(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.nameOrEmail, requestParameters.status, requestParameters.includeInactive, requestParameters.exactMatch, requestParameters.ids, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one platform user by id.
         * @summary Get Platform User
         * @param {UsersApiGetPlatformUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformUser(requestParameters: UsersApiGetPlatformUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<PlatformUser> {
            return localVarFp.getPlatformUser(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get paginated platform users.
         * @summary Get Platform Users
         * @param {UsersApiGetPlatformUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformUsers(requestParameters: UsersApiGetPlatformUsersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PlatformUserPaginated> {
            return localVarFp.getPlatformUsers(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.nameOrEmail, requestParameters.status, requestParameters.includeInactive, requestParameters.exactMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new user (state=invited) in the target organization and email an activation link.  The target organization is resolved once via ``get_organization_schema_from_request`` (path/query/body ``organization_id``, else the caller\'s own org) and used for BOTH the authorization check and the invite, so the two can never diverge. Targeting another org therefore requires platform-wide organization access (superadmin / organization manager), enforced by ``check_if_user_has_organization_rights`` against that same resolved org.  If the email already belongs to a user in the same org → 400. If the email belongs to a user in another org → 400. If the email belongs to an org-less user → silently attach to the target org (no email).
         * @summary Invite User
         * @param {UsersApiInviteUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUser(requestParameters: UsersApiInviteUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationUser> {
            return localVarFp.inviteUser(requestParameters.inviteOrganizationUser, options).then((request) => request(axios, basePath));
        },
        /**
         * List organization roles for a user.
         * @summary List Organization User Roles
         * @param {UsersApiListOrganizationUserRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizationUserRoles(requestParameters: UsersApiListOrganizationUserRolesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<OrganizationRoles>> {
            return localVarFp.listOrganizationUserRoles(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * List platform roles for a user.
         * @summary List Platform User Roles
         * @param {UsersApiListPlatformUserRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlatformUserRoles(requestParameters: UsersApiListPlatformUserRolesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PlatformRoles>> {
            return localVarFp.listPlatformUserRoles(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Override all organization roles for a user.
         * @summary Override Organization User Roles
         * @param {UsersApiOverrideOrganizationUserRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overrideOrganizationUserRoles(requestParameters: UsersApiOverrideOrganizationUserRolesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<OrganizationRoles>> {
            return localVarFp.overrideOrganizationUserRoles(requestParameters.userId, requestParameters.organizationUserRoleBulkUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Override all platform roles for a user.
         * @summary Override Platform User Roles
         * @param {UsersApiOverridePlatformUserRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overridePlatformUserRoles(requestParameters: UsersApiOverridePlatformUserRolesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PlatformRoles>> {
            return localVarFp.overridePlatformUserRoles(requestParameters.userId, requestParameters.platformUserRoleBulkUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a single organization role from a user.
         * @summary Remove Organization User Role
         * @param {UsersApiRemoveOrganizationUserRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOrganizationUserRole(requestParameters: UsersApiRemoveOrganizationUserRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeOrganizationUserRole(requestParameters.roleName, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a single platform role from a user.
         * @summary Remove Platform User Role
         * @param {UsersApiRemovePlatformUserRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePlatformUserRole(requestParameters: UsersApiRemovePlatformUserRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removePlatformUserRole(requestParameters.platformRole, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel any pending invites and send a fresh one. Mirrors v1 semantics.
         * @summary Resend User Invite
         * @param {UsersApiResendUserInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendUserInvite(requestParameters: UsersApiResendUserInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resendUserInvite(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Reset terms acceptance for all users, except users of organizations with custom terms and conditions.  By default the reset is applied and every affected user must re-accept the terms on next login. Pass ``dry_run=true`` to only compute the counts without writing anything.
         * @summary Reset Users Terms Accepted
         * @param {UsersApiResetUsersTermsAcceptedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUsersTermsAccepted(requestParameters: UsersApiResetUsersTermsAcceptedRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TermsReset> {
            return localVarFp.resetUsersTermsAccepted(requestParameters.dryRun, options).then((request) => request(axios, basePath));
        },
        /**
         * Trigger the IdP to email a password-reset link to the target user.
         * @summary Send Password Reset Email
         * @param {UsersApiSendPasswordResetEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPasswordResetEmail(requestParameters: UsersApiSendPasswordResetEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendPasswordResetEmail(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Clear the IdP lock on a user and restore their access.
         * @summary Unlock Organization User
         * @param {UsersApiUnlockOrganizationUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockOrganizationUser(requestParameters: UsersApiUnlockOrganizationUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationUser> {
            return localVarFp.unlockOrganizationUser(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update basic profile fields for an organization user.
         * @summary Update Organization User
         * @param {UsersApiUpdateOrganizationUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationUser(requestParameters: UsersApiUpdateOrganizationUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationUser> {
            return localVarFp.updateOrganizationUser(requestParameters.userId, requestParameters.organizationUserUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the status (state) of an organization user.
         * @summary Update Organization User Status
         * @param {UsersApiUpdateOrganizationUserStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationUserStatus(requestParameters: UsersApiUpdateOrganizationUserStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationUser> {
            return localVarFp.updateOrganizationUserStatus(requestParameters.userId, requestParameters.organizationUserStatusUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addOrganizationUserRole operation in UsersApi.
 */
export interface UsersApiAddOrganizationUserRoleRequest {
    readonly userId: string

    readonly organizationUserRoleUpdate: OrganizationUserRoleUpdate
}

/**
 * Request parameters for addPlatformUserRole operation in UsersApi.
 */
export interface UsersApiAddPlatformUserRoleRequest {
    readonly userId: string

    readonly platformUserRoleUpdate: PlatformUserRoleUpdate
}

/**
 * Request parameters for cancelPendingUserInvites operation in UsersApi.
 */
export interface UsersApiCancelPendingUserInvitesRequest {
    readonly userId: string
}

/**
 * Request parameters for deleteOrganizationUser operation in UsersApi.
 */
export interface UsersApiDeleteOrganizationUserRequest {
    readonly userId: string
}

/**
 * Request parameters for getOrganizationUserSignupLink operation in UsersApi.
 */
export interface UsersApiGetOrganizationUserSignupLinkRequest {
    readonly userId: string
}

/**
 * Request parameters for getOrganizationUsers operation in UsersApi.
 */
export interface UsersApiGetOrganizationUsersRequest {
    readonly page?: number

    readonly size?: number

    readonly sortBy?: UserSorting | null

    readonly descending?: boolean | null

    readonly nameOrEmail?: string | null

    readonly status?: UserState | null

    readonly includeInactive?: boolean | null

    readonly exactMatch?: boolean

    /**
     * Keep only these users. Platform users with full organization access reach any organization.
     */
    readonly ids?: Array<string>
}

/**
 * Request parameters for getPlatformUser operation in UsersApi.
 */
export interface UsersApiGetPlatformUserRequest {
    readonly userId: string
}

/**
 * Request parameters for getPlatformUsers operation in UsersApi.
 */
export interface UsersApiGetPlatformUsersRequest {
    readonly page?: number

    readonly size?: number

    readonly sortBy?: UserSorting | null

    readonly descending?: boolean | null

    readonly nameOrEmail?: string | null

    readonly status?: UserState | null

    readonly includeInactive?: boolean | null

    readonly exactMatch?: boolean
}

/**
 * Request parameters for inviteUser operation in UsersApi.
 */
export interface UsersApiInviteUserRequest {
    readonly inviteOrganizationUser: InviteOrganizationUser
}

/**
 * Request parameters for listOrganizationUserRoles operation in UsersApi.
 */
export interface UsersApiListOrganizationUserRolesRequest {
    readonly userId: string
}

/**
 * Request parameters for listPlatformUserRoles operation in UsersApi.
 */
export interface UsersApiListPlatformUserRolesRequest {
    readonly userId: string
}

/**
 * Request parameters for overrideOrganizationUserRoles operation in UsersApi.
 */
export interface UsersApiOverrideOrganizationUserRolesRequest {
    readonly userId: string

    readonly organizationUserRoleBulkUpdate: OrganizationUserRoleBulkUpdate
}

/**
 * Request parameters for overridePlatformUserRoles operation in UsersApi.
 */
export interface UsersApiOverridePlatformUserRolesRequest {
    readonly userId: string

    readonly platformUserRoleBulkUpdate: PlatformUserRoleBulkUpdate
}

/**
 * Request parameters for removeOrganizationUserRole operation in UsersApi.
 */
export interface UsersApiRemoveOrganizationUserRoleRequest {
    readonly roleName: OrganizationRoles

    readonly userId: string
}

/**
 * Request parameters for removePlatformUserRole operation in UsersApi.
 */
export interface UsersApiRemovePlatformUserRoleRequest {
    readonly platformRole: PlatformRoles

    readonly userId: string
}

/**
 * Request parameters for resendUserInvite operation in UsersApi.
 */
export interface UsersApiResendUserInviteRequest {
    readonly userId: string
}

/**
 * Request parameters for resetUsersTermsAccepted operation in UsersApi.
 */
export interface UsersApiResetUsersTermsAcceptedRequest {
    readonly dryRun?: boolean
}

/**
 * Request parameters for sendPasswordResetEmail operation in UsersApi.
 */
export interface UsersApiSendPasswordResetEmailRequest {
    readonly userId: string
}

/**
 * Request parameters for unlockOrganizationUser operation in UsersApi.
 */
export interface UsersApiUnlockOrganizationUserRequest {
    readonly userId: string
}

/**
 * Request parameters for updateOrganizationUser operation in UsersApi.
 */
export interface UsersApiUpdateOrganizationUserRequest {
    readonly userId: string

    readonly organizationUserUpdate: OrganizationUserUpdate
}

/**
 * Request parameters for updateOrganizationUserStatus operation in UsersApi.
 */
export interface UsersApiUpdateOrganizationUserStatusRequest {
    readonly userId: string

    readonly organizationUserStatusUpdate: OrganizationUserStatusUpdate
}

/**
 * UsersApi - object-oriented interface
 */
export class UsersApi extends BaseAPI {
    /**
     * Assign a single organization role to a user.
     * @summary Add Organization User Role
     * @param {UsersApiAddOrganizationUserRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addOrganizationUserRole(requestParameters: UsersApiAddOrganizationUserRoleRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).addOrganizationUserRole(requestParameters.userId, requestParameters.organizationUserRoleUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Assign a single platform role to a user.
     * @summary Add Platform User Role
     * @param {UsersApiAddPlatformUserRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addPlatformUserRole(requestParameters: UsersApiAddPlatformUserRoleRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).addPlatformUserRole(requestParameters.userId, requestParameters.platformUserRoleUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel every pending invitation for the user.
     * @summary Cancel Pending User Invites
     * @param {UsersApiCancelPendingUserInvitesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelPendingUserInvites(requestParameters: UsersApiCancelPendingUserInvitesRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).cancelPendingUserInvites(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Hard-delete an organization user.
     * @summary Delete Organization User
     * @param {UsersApiDeleteOrganizationUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteOrganizationUser(requestParameters: UsersApiDeleteOrganizationUserRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).deleteOrganizationUser(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the most recent valid pending signup link for an invited user. Mirrors v1.
     * @summary Get Organization User Signup Link
     * @param {UsersApiGetOrganizationUserSignupLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationUserSignupLink(requestParameters: UsersApiGetOrganizationUserSignupLinkRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getOrganizationUserSignupLink(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get paginated organization users for the current user\'s organization.
     * @summary Get Organization Users
     * @param {UsersApiGetOrganizationUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationUsers(requestParameters: UsersApiGetOrganizationUsersRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getOrganizationUsers(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.nameOrEmail, requestParameters.status, requestParameters.includeInactive, requestParameters.exactMatch, requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one platform user by id.
     * @summary Get Platform User
     * @param {UsersApiGetPlatformUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlatformUser(requestParameters: UsersApiGetPlatformUserRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getPlatformUser(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get paginated platform users.
     * @summary Get Platform Users
     * @param {UsersApiGetPlatformUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlatformUsers(requestParameters: UsersApiGetPlatformUsersRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getPlatformUsers(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.nameOrEmail, requestParameters.status, requestParameters.includeInactive, requestParameters.exactMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new user (state=invited) in the target organization and email an activation link.  The target organization is resolved once via ``get_organization_schema_from_request`` (path/query/body ``organization_id``, else the caller\'s own org) and used for BOTH the authorization check and the invite, so the two can never diverge. Targeting another org therefore requires platform-wide organization access (superadmin / organization manager), enforced by ``check_if_user_has_organization_rights`` against that same resolved org.  If the email already belongs to a user in the same org → 400. If the email belongs to a user in another org → 400. If the email belongs to an org-less user → silently attach to the target org (no email).
     * @summary Invite User
     * @param {UsersApiInviteUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inviteUser(requestParameters: UsersApiInviteUserRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).inviteUser(requestParameters.inviteOrganizationUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List organization roles for a user.
     * @summary List Organization User Roles
     * @param {UsersApiListOrganizationUserRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listOrganizationUserRoles(requestParameters: UsersApiListOrganizationUserRolesRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).listOrganizationUserRoles(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List platform roles for a user.
     * @summary List Platform User Roles
     * @param {UsersApiListPlatformUserRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listPlatformUserRoles(requestParameters: UsersApiListPlatformUserRolesRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).listPlatformUserRoles(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Override all organization roles for a user.
     * @summary Override Organization User Roles
     * @param {UsersApiOverrideOrganizationUserRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public overrideOrganizationUserRoles(requestParameters: UsersApiOverrideOrganizationUserRolesRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).overrideOrganizationUserRoles(requestParameters.userId, requestParameters.organizationUserRoleBulkUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Override all platform roles for a user.
     * @summary Override Platform User Roles
     * @param {UsersApiOverridePlatformUserRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public overridePlatformUserRoles(requestParameters: UsersApiOverridePlatformUserRolesRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).overridePlatformUserRoles(requestParameters.userId, requestParameters.platformUserRoleBulkUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a single organization role from a user.
     * @summary Remove Organization User Role
     * @param {UsersApiRemoveOrganizationUserRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeOrganizationUserRole(requestParameters: UsersApiRemoveOrganizationUserRoleRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).removeOrganizationUserRole(requestParameters.roleName, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a single platform role from a user.
     * @summary Remove Platform User Role
     * @param {UsersApiRemovePlatformUserRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removePlatformUserRole(requestParameters: UsersApiRemovePlatformUserRoleRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).removePlatformUserRole(requestParameters.platformRole, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel any pending invites and send a fresh one. Mirrors v1 semantics.
     * @summary Resend User Invite
     * @param {UsersApiResendUserInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resendUserInvite(requestParameters: UsersApiResendUserInviteRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).resendUserInvite(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reset terms acceptance for all users, except users of organizations with custom terms and conditions.  By default the reset is applied and every affected user must re-accept the terms on next login. Pass ``dry_run=true`` to only compute the counts without writing anything.
     * @summary Reset Users Terms Accepted
     * @param {UsersApiResetUsersTermsAcceptedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resetUsersTermsAccepted(requestParameters: UsersApiResetUsersTermsAcceptedRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).resetUsersTermsAccepted(requestParameters.dryRun, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Trigger the IdP to email a password-reset link to the target user.
     * @summary Send Password Reset Email
     * @param {UsersApiSendPasswordResetEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendPasswordResetEmail(requestParameters: UsersApiSendPasswordResetEmailRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).sendPasswordResetEmail(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Clear the IdP lock on a user and restore their access.
     * @summary Unlock Organization User
     * @param {UsersApiUnlockOrganizationUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unlockOrganizationUser(requestParameters: UsersApiUnlockOrganizationUserRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).unlockOrganizationUser(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update basic profile fields for an organization user.
     * @summary Update Organization User
     * @param {UsersApiUpdateOrganizationUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateOrganizationUser(requestParameters: UsersApiUpdateOrganizationUserRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateOrganizationUser(requestParameters.userId, requestParameters.organizationUserUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the status (state) of an organization user.
     * @summary Update Organization User Status
     * @param {UsersApiUpdateOrganizationUserStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateOrganizationUserStatus(requestParameters: UsersApiUpdateOrganizationUserStatusRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateOrganizationUserStatus(requestParameters.userId, requestParameters.organizationUserStatusUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

